import { defineStyleConfig } from "@chakra-ui/react"

export const inputTheme = defineStyleConfig({
  baseStyle: props => ({
    field: {
      color: props.colorMode === "light" ? "gray.800" : "white",
      _placeholder: {
        color: props.colorMode === "light" ? "gray.500" : "whiteAlpha.700",
      },
    },
  }),
})
